import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TFooterComponent } from "./t-footer/t-footer.component";

@NgModule({
  declarations: [TFooterComponent],
  imports: [CommonModule],
  exports: [TFooterComponent],
})
export class TFooterModule {}
